import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import {Translate} from "../../../../config/Translate";

import FileManager from "../FileManager";
import {defaultVariabls} from "../../../../config/index";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import MoveToDirectoryDialog from "./MoveToDirectoryDialog";
import ControlCameraRoundedIcon from '@material-ui/icons/ControlCameraRounded';

class ImgPreviewModal extends React.Component{
    state = {
        open: false
    };
    classes = this.props.classes;
    toggle = () => {
        this.setState({
            open:!this.state.open
        });
    };
    reload(){
        this.toggle();
        this.props.reload()
    }
    render(){
        let {open} = this.state;
        return(
            <>
                <Tooltip title={Translate.moveFilesToDirectory}>
                    <IconButton size="small" color="primary" onClick={() => this.toggle()} style={{margin:"0 5px"}}>
                        <ControlCameraRoundedIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
                {
                    !!open &&
                    <MoveToDirectoryDialog
                        items={[this.props.data]}
                        reload={() => this.reload()}
                        hanleClose={() => this.setState({
                            open:false,
                        })}
                    />
                }

            </>
        )
    }
}
export default  withStyles(Styles)(ImgPreviewModal)